const imageUploader = async (file: any) => {
	const data = new FormData();
	data.append("file", file);
	data.append("upload_preset", "gdf6eege");

	const result = await fetch("https://api.cloudinary.com/v1_1/dbyl7mbbg/image/upload", {
		method: "POST",
		body: data,
	});
	return await result.json();
};

export default imageUploader;
